import React, { useState } from "react";
import "../../styles.scss";
import { useGetReportInformationFirstStepQuery } from "features/api/reports/reportsSlice";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import ReportDetailsForm from "components/Reports/ReportDetails/components/ReportDetailsForm";
import { Spinner } from "react-bootstrap";
import { useAppSelector } from "hooks/reduxToolkit";
import { ReportInformationFirstStep } from "models/ReportInformationFirstStep";
import { reportContainerProps } from "../../types";

const MessagesReportContainer = ({ setIsOpen }: reportContainerProps) => {
  const [currStep, setCurrStep] = useState(1);
  const reportId = useAppSelector(
    (state) => state.reportsSliceReducer.reportId
  );
  const selectedRole = useGetUserData(LocalStorageKey.SelectedRole)?.value;

  const { data: reportDetails }: { data: ReportInformationFirstStep } =
    useGetReportInformationFirstStepQuery<ReportInformationFirstStep>({
      reportID: reportId,
      role: selectedRole,
      isInProgress: false,
    });

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="MessagesReportContainer">
      {reportDetails ? (
        <ReportDetailsForm
          currStep={currStep}
          setCurrStep={setCurrStep}
          reportDetails={reportDetails}
          handleClose={handleClose}
        />
      ) : (
        <div className="loader-container">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </div>
  );
};

export default MessagesReportContainer;
